import { render } from "./schoolSafeCreate.vue?vue&type=template&id=f36f74ea"
import script from "./schoolSafeCreate.vue?vue&type=script&lang=js"
export * from "./schoolSafeCreate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__